export default {
  steps: [
    {
      title: 'Cadastro',
      icon: 'CheckIcon',
      completed: true,
      current: false,
      path: '/step/register',
      order: 0,
    },
    {
      title: 'Informações Básicas',
      icon: 'FileTextIcon',
      completed: false,
      current: false,
      path: 'step-basic-info',
      order: 1,
    },
    {
      title: 'Diversidade e Inclusão',
      icon: 'UsersIcon',
      completed: false,
      current: false,
      path: 'step-diversity',
      order: 2,
    },
    {
      title: 'Currículo',
      icon: 'FileTextIcon',
      completed: false,
      current: false,
      path: 'step-curriculumn',
      order: 3,
    },
    {
      title: 'Endereço',
      icon: 'PhoneIcon',
      completed: false,
      current: false,
      path: 'step-address',
      order: 4,
    },
    {
      title: 'Formação',
      icon: 'BookIcon',
      completed: false,
      current: false,
      path: 'step-formation',
      order: 5,
    },
    {
      title: 'Experiências',
      icon: 'AwardIcon',
      completed: false,
      current: false,
      path: 'step-experiences',
      order: 6,
    },
    {
      title: 'Idiomas',
      icon: 'MessageSquareIcon',
      completed: false,
      current: false,
      path: 'step-languages',
      order: 7,
    },
    {
      title: 'Habilidades',
      icon: 'StarIcon',
      completed: false,
      current: false,
      path: 'step-skills',
      order: 8,
    },
    {
      title: "Programa de Indicação",
      icon: "GiftIcon",
      completed: false,
      current: false,
      path: "step-referral-program",
      order: 9,
    },
    {
      title: "Revisão",
      icon: "ThumbsUpIcon",
      completed: false,
      current: false,
      path: "step-revision",
      order: 10,
    }
  ],
  currentStep: 1,
  secondStep: 1,
  step: {
    progress: 10
  },
  basicFormSubmit: {trigger: false, goTo: undefined},
}